<div class="file-attachment-wrapper">
  <div class="attachments-label">
    {{ 'LABEL.ATTACHMENTS' | translate }}
    <span
      *ngIf="combinedFileAttachments$ | async as combinedFileAttachments"
      class="number-of-attachments"
    >
      ({{
        combinedFileAttachments.size === totalAttachmentNumber
          ? ('FILE_ATTACHMENT.10_MAX'
            | translate: { maxCount: totalAttachmentNumber + 1 })
          : combinedFileAttachments.size + 1
      }})
    </span>
    <div class="divider"></div>
  </div>

  <div
    class="add-attachment-section"
    *ngIf="combinedFileAttachments$ | async as combinedFileAttachments"
  >
    <div class="new-added-attachment attachment-border">
      <div class="close-icon-wrapper">
        <i2g-icon
          class="close-icon"
          [icon]="closeIcon"
          [class.hidden]="true"
        ></i2g-icon>
      </div>
      <div class="pdf-icon-wrapper">
        <i2g-icon
          class="attachment-blue-icon"
          [icon]="attachmentBlueIcon"
        ></i2g-icon>
        <span class="pdf-text">pdf</span>
      </div>
      <div class="attachment-filename">
        {{ formattedAttachmentName }}
      </div>
      <div class="attachment-size">{{ readableAttachmentSize }}</div>
    </div>

    <div
      *ngFor="let attachment of combinedFileAttachments"
      class="new-added-attachment attachment-border"
    >
      <div class="close-icon-wrapper">
        <i2g-icon
          class="close-icon"
          [icon]="closeIcon"
          (click)="onDeleteAttachment(attachment.id)"
          i2gTrackable
          [trackingObject]="trackingObject"
          [trackingAction]="deleteAttachmentAction"
        >
        </i2g-icon>
      </div>
      <div class="pdf-icon-wrapper">
        <i2g-icon
          class="attachment-blue-icon"
          [icon]="attachmentBlueIcon"
        ></i2g-icon>
        <span class="pdf-text">pdf</span>
      </div>
      <div class="attachment-filename">
        {{ attachment.title }}
      </div>
      <div class="attachment-size">
        {{ attachment.size }}
      </div>
    </div>
    <div *ngIf="showUploadingIcon">
      <div class="custom-icon-wrapper attachment-border">
        <i2g-icon
          class="custom-icon loading-spinner"
          [icon]="loadingIcon"
        ></i2g-icon>
      </div>
    </div>

    <div
      *ngIf="combinedFileAttachments$ | async as combinedFileAttachments"
      class="add-button-wrapper"
    >
      <div
        *ngIf="
          combinedFileAttachments.size < totalAttachmentNumber &&
          !showUploadingIcon
        "
      >
        <label
          class="custom-icon-wrapper attachment-border"
          [attr.for]="attachmentSelectId"
          i2gTrackable
          [trackingObject]="trackingObject"
          [trackingAction]="addAttachmentAction"
        >
          <i2g-icon class="custom-icon" [icon]="attachmentClipIcon"></i2g-icon>
        </label>
        <input
          type="file"
          [attr.accept]="acceptableFileTypes"
          [attr.for]="attachmentSelectId"
          [attr.id]="attachmentSelectId"
          hidden
          [multiple]="true"
          (change)="onAddFiles($event)"
        />
      </div>
    </div>
  </div>
</div>
